import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import ConfirmationText from './ConfirmationText';
import { PaymentConfirmationProps } from '../types';

const Wrapper = styled.div`
  text-align: left;
`;

export const Confirmation: FunctionComponent<Omit<
  PaymentConfirmationProps,
  'quoteNumber' | 'policyStartDate'
>> = ({
  receiptNumber,
  contactEmail,
  paymentMethod,
  paymentFrequency,
  paymentDate,
  firstInstalment,
  monthlyInstalment,
}) => (
  <Wrapper>
    <ConfirmationText
      receiptNumber={receiptNumber}
      contactEmail={contactEmail}
      paymentMethod={paymentMethod}
      paymentFrequency={paymentFrequency}
      paymentDate={paymentDate}
      firstInstalment={firstInstalment}
      monthlyInstalment={monthlyInstalment}
    />
  </Wrapper>
);

export default Confirmation;
